import PropTypes from 'prop-types';
import React from 'react';
import Popup from 'reactjs-popup';
import KebabIcon from '../../shared/Icons/KebabIcon';
import { buildRowActions } from '../utils/rowActions';

// reactjs-popup applies its own chrome to .popup-content; neutralize it so the
// .tickets-actions-menu box (border/shadow/padding) is the only visible surface.
const popupContentStyle = {
  border: 'none',
  padding: 0,
  background: 'transparent',
  boxShadow: 'none',
  width: 'auto',
};

function RowActionsMenu({ team, event }) {
  const items = buildRowActions(team, event);

  return (
    <Popup
      on="click"
      arrow={false}
      offsetY={4}
      position="bottom right"
      closeOnDocumentClick
      contentStyle={popupContentStyle}
      trigger={(open) => (
        <button
          type="button"
          className="tickets-action-btn"
          aria-label="More actions"
          aria-haspopup="true"
          aria-expanded={open}
        >
          <KebabIcon />
        </button>
      )}
    >
      {(close) => (
        <div className="tickets-actions-menu" role="menu">
          {items.map((item) => (
            <a
              key={item.key}
              href={item.href}
              className="tickets-actions-menu-item"
              role="menuitem"
              onClick={close}
            >
              <item.Icon />
              <span>{item.label}</span>
            </a>
          ))}
        </div>
      )}
    </Popup>
  );
}

RowActionsMenu.propTypes = {
  team: PropTypes.shape({ id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired }).isRequired,
  event: PropTypes.shape({ id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired }).isRequired,
};

export default RowActionsMenu;
